import React from 'react';
import { Box, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';
import pluralize from 'pluralize';
import { dateToMonthAndYear } from 'services/dateFormatter';

const Experience = ({ experience }) => {
  const timeSpent = (dateTo, dateFrom) => {
    const fromDate = new Date(dateFrom);
    const toDate = dateTo ? new Date(dateTo) : new Date();

    const years = moment(toDate).diff(fromDate, 'years');
    const months = moment(toDate).diff(moment(fromDate).add(years, 'years'), 'months');

    const yearsString = `${years > 0 ? `${years} ${pluralize('year', years)}` : ''}`;
    const monthsString = `${months > 0 ? `${months} ${pluralize('month', months)}` : ''}`;

    return `${yearsString} ${monthsString}`;
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0',
      }}
    >
      <Box>
        <Text fontSize="14px" fontWeight="500" color="text.dark">
          {experience.jobTitle}
        </Text>
      </Box>
      <Box>
        <Text fontSize="14px" color="text.subtle">
          {dateToMonthAndYear(experience.dateFrom)} to{' '}
          {experience.dateTo ? dateToMonthAndYear(experience.dateTo) : 'present'} ·{' '}
          {timeSpent(experience.dateTo, experience.dateFrom)}
        </Text>
      </Box>
    </Box>
  );
};

Experience.propTypes = {
  experience: PropTypes.object.isRequired,
};

export default Experience;
